/**
 * General actions script file
 *
 * @package    Actions
 * @author     Vadym Karpenko <vkarpenko@mindk.com>
 * @copyright  Copyright (c) 2010-2018 MindK (http://mindk.com). All rights reserved.
 * @license    http://mindk.com
 * @link       http://mindk.com
 */

export const SET_LOCALE = 'SET_LOCALE';

/**
 * Set locale
 *
 * @param locale
 *
 * @returns {Object}
 */
export function setLocale(locale) {
    return function (dispatch) {
        dispatch({
            type: SET_LOCALE,
            locale,
        });
    };
}



// WEBPACK FOOTER //
// ./src/actions/general.js